/**
 * Smooth Image Transitions for Product Gallery
 * Adds fade transitions when switching between product images
 */
(function() {
  'use strict';

  let transitionTimeout = null;

  function initSmoothTransitions() {
    const tabContainer = document.querySelector('.brator-product-img-tab-list.js-tabs');
    if (!tabContainer) return;

    const tabContents = tabContainer.querySelectorAll('.js-tabs__content');
    const tabTitles = tabContainer.querySelectorAll('.js-tabs__title');
    
    if (tabContents.length === 0 || tabTitles.length === 0) return;

    // Remove transitions for instant image changes
    tabContents.forEach(function(content) {
      content.style.transition = 'none';
    });

    // Intercept tab clicks for smooth transitions
    tabTitles.forEach(function(title, index) {
      // Remove existing listeners by cloning
      const newTitle = title.cloneNode(true);
      title.parentNode.replaceChild(newTitle, title);
      
      newTitle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const targetContent = tabContents[index];
        if (!targetContent) return;

        // Find currently visible content
        const currentContent = Array.from(tabContents).find(function(content) {
          const style = window.getComputedStyle(content);
          return style.display !== 'none' && parseFloat(style.opacity) > 0;
        });

        // If clicking the same tab, do nothing
        if (currentContent === targetContent) return;

        // Clear any pending timeouts
        if (transitionTimeout) {
          clearTimeout(transitionTimeout);
          transitionTimeout = null;
        }

        // Hide current content instantly (no transition)
        if (currentContent) {
          currentContent.style.display = 'none';
          currentContent.style.visibility = 'hidden';
          currentContent.style.opacity = '1';
          currentContent.style.transform = 'scale(1)';
        }

        // Show new content instantly (no transition)
        targetContent.style.display = '';
        targetContent.style.visibility = 'visible';
        targetContent.style.opacity = '1';
        targetContent.style.transform = 'scale(1)';

        // Update active tab title (including thumbnails)
        tabTitles.forEach(function(t) {
          t.classList.remove('js-tabs__title-active');
        });
        newTitle.classList.add('js-tabs__title-active');
        
        // Also update thumbnail triggers in slider
        const thumbnailTriggers = document.querySelectorAll('.product-thumbnail-trigger');
        thumbnailTriggers.forEach(function(trigger) {
          const triggerMediaId = trigger.getAttribute('data-media-id');
          const targetMediaId = targetContent.getAttribute('data-media-id');
          if (triggerMediaId === targetMediaId) {
            trigger.classList.add('js-tabs__title-active');
          } else {
            trigger.classList.remove('js-tabs__title-active');
          }
        });
      });
    });

    // Handle instant image changes for variant changes (no transitions)
    function applySmoothTransition(content, show) {
      if (show) {
        // Show instantly
        content.style.display = '';
        content.style.visibility = 'visible';
        content.style.opacity = '1';
        content.style.transform = 'scale(1)';
      } else {
        // Hide instantly
        content.style.display = 'none';
        content.style.visibility = 'hidden';
        content.style.opacity = '1';
        content.style.transform = 'scale(1)';
      }
    }

    // Observe for variant changes and style updates (instant changes, no transitions)
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          const target = mutation.target;
          if (target.classList.contains('js-tabs__content')) {
            const style = window.getComputedStyle(target);
            const wasVisible = mutation.oldValue && !mutation.oldValue.includes('display: none');
            const isVisible = style.display !== 'none' && style.display !== '';
            
            // Instant change - no transitions
            if (isVisible && !wasVisible) {
              target.style.transition = 'none';
              target.style.display = '';
              target.style.visibility = 'visible';
              target.style.opacity = '1';
              target.style.transform = 'scale(1)';
            }
            // Instant hide - no transitions
            else if (!isVisible && wasVisible) {
              target.style.transition = 'none';
              target.style.display = 'none';
              target.style.visibility = 'hidden';
              target.style.opacity = '1';
              target.style.transform = 'scale(1)';
            }
          }
        }
      });
    });

    // Observe all tab contents for style changes
    tabContents.forEach(function(content) {
      observer.observe(content, {
        attributes: true,
        attributeFilter: ['style'],
        attributeOldValue: true
      });
    });

    // Set initial state - ensure all images are visible initially
    setTimeout(function() {
      tabContents.forEach(function(content) {
        const style = window.getComputedStyle(content);
        if (style.display !== 'none') {
          content.style.opacity = '1';
          content.style.transform = 'scale(1)';
          content.style.visibility = 'visible';
        } else {
          content.style.opacity = '0';
          content.style.visibility = 'hidden';
        }
      });
    }, 100);
  }

  // Wait for tab.js to initialize first
  function waitForTabs() {
    const tabContainer = document.querySelector('.brator-product-img-tab-list.js-tabs');
    if (tabContainer && tabContainer.querySelectorAll('.js-tabs__title').length > 0) {
      setTimeout(initSmoothTransitions, 200);
    } else {
      setTimeout(waitForTabs, 100);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(waitForTabs, 300);
    });
  } else {
    setTimeout(waitForTabs, 300);
  }

  // Re-initialize on dynamic content updates
  if (typeof Shopify !== 'undefined') {
    document.addEventListener('shopify:section:load', function() {
      setTimeout(waitForTabs, 300);
    });
  }
})();

